import React from 'react'
import Logo from "../assets/images/TCUK-Logo.png";
import '../components/styles/HeaderLogo.css';

function HeaderLogo() {
  return (
    <div className="header">
        <img src={Logo} alt="TCUK Logo" className="header-logo" />
        <h1 className="title">TCUK SADMIN</h1>
      </div>
  )
}

export default HeaderLogo